document.addEventListener('DOMContentLoaded', () => {
  // ========== FAQ ACCORDION ==========
  document.querySelectorAll('.pp-faq-item__question').forEach(btn => {
    btn.addEventListener('click', () => {
      const item = btn.closest('.pp-faq-item');
      const isActive = item.classList.contains('active');

      // Close all siblings
      item.closest('.pp-faq-list').querySelectorAll('.pp-faq-item').forEach(faq => {
        faq.classList.remove('active');
      });

      // Toggle current
      if (!isActive) {
        item.classList.add('active');
      }
    });
  });

  // ========== SCROLL ANIMATIONS ==========
  const observerOptions = {
    threshold: 0.1,
    rootMargin: '0px 0px -40px 0px'
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        observer.unobserve(entry.target);
      }
    });
  }, observerOptions);

  document.querySelectorAll('.pp-animate').forEach(el => {
    observer.observe(el);
  });

  // ========== INFOGRAPHIC CIRCLES ==========
  const circleObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const circle = entry.target;
        const targetProgress = parseInt(circle.dataset.progress || '0');
        let current = 0;
        const step = targetProgress / 40; // 40 frames

        const animate = () => {
          current = Math.min(current + step, targetProgress);
          circle.style.setProperty('--progress', current + '%');
          if (current < targetProgress) {
            requestAnimationFrame(animate);
          }
        };

        requestAnimationFrame(animate);
        circleObserver.unobserve(circle);
      }
    });
  }, { threshold: 0.3 });

  document.querySelectorAll('.pp-infographic-circle').forEach(circle => {
    circleObserver.observe(circle);
  });

  // ========== STAT COUNTER ANIMATION ==========
  const counterObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const el = entry.target;
        const target = el.dataset.count;
        if (!target) return;

        const isPercentage = target.includes('%');
        const isPlus = target.includes('+');
        const numVal = parseInt(target.replace(/[^0-9]/g, ''));
        const suffix = target.replace(/[0-9]/g, '');
        let current = 0;
        const increment = numVal / 50;

        const updateCounter = () => {
          current += increment;
          if (current >= numVal) {
            el.textContent = target;
          } else {
            el.textContent = Math.floor(current) + suffix;
            requestAnimationFrame(updateCounter);
          }
        };

        requestAnimationFrame(updateCounter);
        counterObserver.unobserve(el);
      }
    });
  }, { threshold: 0.5 });

  document.querySelectorAll('[data-count]').forEach(el => {
    counterObserver.observe(el);
  });
});
